import React from 'react';
import ManageCatalogue from '../../admin/pages/ManageCatalogue';

/** User-facing catalogue manager for the logged-in account. */
const UserCatalogue = () => <ManageCatalogue mode="user" />;

export default UserCatalogue;
